import { useState, ReactNode, ChangeEvent } from 'react';
import { uniqueId } from 'lodash';

import { ReactComponent as AttachIcon } from '~assets/icons/attach.svg';

import * as styled from './styled';

function InputFileButton({
  children,
  onChange,
  accept,
}: {
  children: ReactNode;
  onChange: (file?: File) => void;
  accept?: string;
}) {
  const [id] = useState(uniqueId('input-file-button-'));

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    onChange(e.currentTarget.files[0]);
  }

  return (
    <>
      <styled.FakeButton htmlFor={id}>
        {children}
        <AttachIcon />
      </styled.FakeButton>
      <input
        type="file"
        id={id}
        onChange={handleChange}
        accept={accept}
        hidden
      />
    </>
  );
}

export default InputFileButton;
